import BaseService from './base'
export default class BrokerService extends BaseService {
  static resource() {
    return 'api/v1/broker'
  }
}
